import { StyleSheet } from 'aphrodite/no-important';

let styles = {
  group: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '100%'
  },
  field: {
    width: '48%'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/forms/formgroup/FormGroup.styles.js